/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import ProgressBar from 'DesignSystem/ProgressBar/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/New/Actions/Content/Lock/Content"
  
}) {
let constantData = 'Preparing statements:'
let selectedSelectedRowsLengthValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'selected_rows.length',
})
let aggregateData = fromAggregate.join(constantData, selectedSelectedRowsLengthValueData)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let selectedMergedProgressValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'merged.progress',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 dangerouslyBypassFocusLock={true}
 size="medium"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 data="'Preparing statements:'"
 data="selected.selected_rows.length"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="This may take a while, so please be patient."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 size="large"
 text="This modal will close itself once the process is done."
/>
<ProgressBar
  viewPath={`${viewPath}/ProgressBar`}
 marginTop={dtSpaceS}
 data="selected.merged.progress"
 value={selectedMergedProgressValueData}
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}